import { render, staticRenderFns } from "./BulmaCarouselModal.vue?vue&type=template&id=0438a29c"
import script from "./BulmaCarouselModal.vue?vue&type=script&lang=js"
export * from "./BulmaCarouselModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0438a29c')) {
      api.createRecord('0438a29c', component.options)
    } else {
      api.reload('0438a29c', component.options)
    }
    module.hot.accept("./BulmaCarouselModal.vue?vue&type=template&id=0438a29c", function () {
      api.rerender('0438a29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaCarousel/BulmaCarouselModal.vue"
export default component.exports